<template>
    <div class="profile-statuses">
        <wall-form v-if="owner" class="profile-update" post-type="profile" :can-add-moods="true"></wall-form>
        <wall-post v-for="status in statuses" :key="status.id" :post="status"></wall-post>
        <infinite v-if="canLoadMore" :loading="loading" :handler="fetch" :handleOnMount="false"></infinite>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import ajax from 'Site/js/util/ajax.fetch';
import Infinite from 'Site/component/Infinite.vue';
import WallForm from 'Wall/component/Form.vue';
import WallPost from 'Wall/component/Post.vue';

export default {
    name: 'ProfileStatuses',
    components: {
        Infinite,
        WallForm,
        WallPost,
    },
    computed: {
        ...mapState({
            owner: state => state.config.data.owner,
            id: state => state.config.data.id,
        }),
    },
    data() {
        return {
            canLoadMore: true,
            limit: 10,
            loading: true,
            offset: 10,
            statuses: [],
        };
    },
    methods: {
        fetch() {
            this.loading = true;
            // Handle loading the page from the Controller & API calls that follow
            if (!this.statuses.length) {
                this.offset = 0;
            }
            ajax.get('wall', {
                foreign: this.id,
                type: 'profile',
                'start-index': this.offset,
                'max-results': this.limit
            }).then((response) => {
                if (response.items && response.items.length) {
                    this.offset += 10;
                    this.loading = false;
                    response.items.forEach((item) => {
                        this.statuses.push(item);
                    });
                } else {
                    this.canLoadMore = false;
                }
            });
        },
    },
    created() {
        const setData = (settings, json = false) => {
            if (json) {
                settings = JSON.parse(settings);
            }
            this.statuses = settings.data.statuses;
            this.loading = false;
        };
        if (document.querySelector('#statuses-json')) {
            const settings = document.querySelector('#statuses-json').textContent;
            if (settings) {
                setData(settings, true);
            }
        } else {
            this.fetch();
        }
    },
};
</script>

<style lang="scss" scoped>
@import "~Site/scss/variables";
</style>

